import { issueRefundAtStatusValues } from '@/common/constants'

import { triggerModeValues } from '../constants'

export const refundTriggerOptions = [
  {
    label: 'Cuando los productos hayan sido enviados por el cliente (Estado Enviado)',
    value: issueRefundAtStatusValues.shipped,
  },
  {
    label: 'Cuando los productos hayan sido recibidos en mi almacén (Estado Recibido)',
    value: issueRefundAtStatusValues.received,
  },
  {
    label: 'Al aceptar los productos devueltos (Estado Aceptado)',
    value: issueRefundAtStatusValues.accepted,
  },
]

export const refundTriggerModeOptions = [
  { label: 'Emitir el reembolso cuando ocurra este trigger', value: triggerModeValues.atTrigger },
  { label: 'Retrasar un número específico de días', value: triggerModeValues.delayByDays },
]
